module.exports = require("./extender.js");


//////////////////
// WEBPACK FOOTER
// ./~/extender/index.js
// module id = 1512
// module chunks = 0